import { ComponentType, Fragment, memo } from 'react';
import { I18nKey, Namespace, useTranslation, Trans } from 'react-i18next';

import { HelpIconWithTooltip } from '~/lib/helpIconWithTooltip';

interface Props {
  hasHelperText?: boolean;
  header?: boolean;
  id?: string;
  i18nKey: I18nKey;
  parent?: string | ComponentType<{ id?: string }> | null;
  tOptions?: Record<string, unknown>;
  tooltipOptions?: Record<string, unknown>;
  tooltipTestId?: string;
}

export const ColumnHeader = memo<Props>(function ColumnHeader({
  hasHelperText,
  header,
  id,
  i18nKey,
  parent = 'span',
  tOptions,
  tooltipOptions,
  tooltipTestId,
}) {
  const [t] = useTranslation<Namespace>();
  const Parent = parent === null ? Fragment : parent;

  // Needs to be a span and not a fragment or else setting
  // align="right" will apply flex-direction: row-reverse
  // which will reverse the elements
  return (
    <Parent id={id}>
      {t(i18nKey, tOptions)}
      {header && hasHelperText && (
        <HelpIconWithTooltip
          sx={{ fontSize: '100%' }}
          tooltipTestId={tooltipTestId}
          tooltipText={
            <Trans
              i18nKey={i18nKey}
              t={t}
              tOptions={{
                context: 'helperText',
                // Keeping tOptions here to not break existing uses of this component. Might be removable in the future.
                ...tOptions,
                ...tooltipOptions,
              }}
            />
          }
        />
      )}
    </Parent>
  );
});
